import { ReactElement, memo } from 'react';

import { AssistantGenerateRoutesActionMenuItemProps } from './types';
import {
  AssistantGenerateRoutesActionMenuItemAccessFeatureContainer,
  AssistantGenerateRoutesActionMenuItemContainer,
} from './styles';

const AssistantGenerateRoutesActionMenuItem = ({
  validSubscriptionFeature,
  ...restProps
}: AssistantGenerateRoutesActionMenuItemProps): ReactElement => {
  if (validSubscriptionFeature) {
    return (
      <AssistantGenerateRoutesActionMenuItemAccessFeatureContainer
        {...validSubscriptionFeature}
        {...restProps}
      />
    );
  }

  return <AssistantGenerateRoutesActionMenuItemContainer {...restProps} />;
};

export default memo(AssistantGenerateRoutesActionMenuItem);
